var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 5.11353C14.3808 5.11353 15.9092 6.64191 15.9092 8.52261C15.9092 10.4033 14.3808 11.9317 12.5001 11.9317C10.6194 11.9317 9.09101 10.4033 9.09101 8.52261C9.09101 6.64191 10.6194 5.11353 12.5001 5.11353Z",
    fill: "#1B9075"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C18.1818 0 23.0341 3.53405 25 8.52271C23.0341 13.5113 18.1818 17.0454 12.5 17.0454C6.81252 17.0454 1.96592 13.5113 0 8.52271C1.96592 3.53405 6.81252 0 12.5 0ZM12.5 14.2045C15.6364 14.2045 18.1818 11.659 18.1818 8.52266C18.1818 5.3863 15.6364 2.84089 12.5 2.84089C9.36364 2.84089 6.81817 5.38636 6.81817 8.52271C6.81817 11.6591 9.36364 14.2045 12.5 14.2045Z",
    fill: "#1B9075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye_open.9b8600f6292b73e33230c4ee5fea3413.svg";
export { ForwardRef as ReactComponent };